import BaseService from "@/service/base.service";

const state = {
  DivNo: "",
  DivName: "",
  DivShortName: "",
  EmpName: "",
  EmpID: "",
  PostionName: "",
  CompID: "",
  Roles: [],
  CathayNo: ""
};

const getters = {
  user: state => state
};

const actions = {
  login({ commit }, obj) {
    const relayState = window.location.origin + window.location.pathname;

    const samlform = document.createElement("form");
    samlform.action = process.env.VUE_APP_API_HOST + BaseService.samlLogin;
    samlform.method = "POST";

    const relayStateInput = document.createElement("input");
    relayStateInput.type = "hidden";
    relayStateInput.name = "relayState";
    relayStateInput.value = btoa(encodeURIComponent(relayState));

    samlform.appendChild(relayStateInput);
    document.body.appendChild(samlform);
    samlform.submit();
  },
  getUserObject({ commit }, obj) {
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(BaseService.getUserObject, obj).then(resp => {
        if (resp.returnCode === 0) {
          commit("setUser", resp.data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  isLoggedIn({ commit }, obj) {
    // 處理登入邏輯.
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(BaseService.isLoggedIn, obj).then(resp => {
        resolve(resp);
      });
    });
  },
  logout({ commit }, obj) {
    window.location.href = this._vm.$conf.LOGOUT_URL;
  }
};

const mutations = {
  setUser(state, obj) {
    if (obj) {
      state.DivNo = obj.divNo;
      state.DivName = obj.divFullName;
      state.DivShortName = obj.divShortName;
      state.EmpName = obj.empName;
      state.EmpID = obj.empID;
      state.PostionName = obj.cepsnnm;
      state.CompID = obj.compID;
      state.Roles = obj.roles;
      state.CathayNo = obj.cathayNo;
    } else {
      state.DivNo = "";
      state.DivName = "";
      state.DivShortName = "";
      state.EmpName = "";
      state.EmpID = "";
      state.PostionName = "";
      state.CompID = "";
      state.Roles = [];
      state.CathayNo = "";
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
